define('adminApiStatsBlockView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'marionette',
  'moment',
  'bootbox',
  'template!adminApiStatsBlockTpl',
  'entities/admin/api_stats'
], function (
  Module,
  App,
  _,
  $,
  Marionette,
  moment,
  bootbox,
  tpl
) {
  'use strict';

  var EXPIRY_HOURS = { never: null, '1h': 1, '24h': 24, '7d': 24 * 7, '30d': 24 * 30 };
  var PERIOD_HOURS = { '24h': 24, '7d': 24 * 7, '30d': 24 * 30 };
  var SOURCE_TABS = ['IP', 'ORIGIN', 'HOST'];
  // Private, loopback and link-local ranges: the address of a proxy, not of a visitor.
  var PRIVATE_IP = /^(10\.|127\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.|169\.254\.|::1$|f[cd][0-9a-f]{2}:|fe80:)/i;

  /** IP / origin / host blocking, shown inside the API statistics screen (DEV TEAM super users). */
  Module.exports = Marionette.ItemView.extend({
    template: tpl,
    className: 'api-block',

    events: {
      'submit .js-rule-form': 'onCreate',
      'change .js-new-type': 'onTypeChange',
      'click .js-toggle': 'onToggle',
      'click .js-delete': 'onDelete',
      'click .js-source-tab': 'onSourceTab',
      'click .js-period': 'onPeriod',
      'submit .js-source-search': 'onSearch',
      'click .js-block-source': 'onBlockSource'
    },

    initialize: function () {
      this.rules = [];
      this.sources = [];
      this.whoami = null;
      this.sourceType = 'IP';
      this.period = '24h';
      this.search = '';
      this.newType = 'IP';
      this.formError = null;
      this.loadingRules = true;
      this.loadingSources = true;
      this.error = false;
    },

    serializeData: function () {
      var that = this;
      var ip = this.whoami && this.whoami.ip;
      return {
        whoami: this.whoami,
        proxyIp: !!(ip && PRIVATE_IP.test(ip)),
        rules: _.map(this.rules, function (r) { return that.ruleView(r); }),
        sources: _.map(this.sources, function (s) { return that.sourceView(s); }),
        sourceTabs: SOURCE_TABS,
        sourceType: this.sourceType,
        period: this.period,
        search: this.search,
        newType: this.newType,
        placeholder: this.newType === 'IP' ? '203.0.113.7  ·  203.0.113.0/24' : 'evil.example  ·  *.evil.example',
        formError: this.formError,
        loadingRules: this.loadingRules,
        loadingSources: this.loadingSources,
        error: this.error,
        enforcedCount: _.where(this.rules, { enforced: true }).length
      };
    },

    onShow: function () {
      var that = this;
      App.request('apiBlock:whoami').done(function (data) {
        that.whoami = data;
        that.render();
      });
      this.loadRules();
      this.loadSources();
    },

    // ---------- data -----------------------------------------------------

    loadRules: function () {
      var that = this;
      App.request('apiBlock:rules').done(function (rules) {
        that.rules = rules || [];
      }).fail(function () {
        that.error = true;
      }).always(function () {
        that.loadingRules = false;
        that.render();
      });
    },

    loadSources: function () {
      var that = this;
      var to = moment();
      this.loadingSources = true;
      this.render();
      App.request('apiBlock:sources', {
        type: this.sourceType,
        from: to.clone().subtract(PERIOD_HOURS[this.period], 'hours').startOf('hour').valueOf(),
        to: to.valueOf() + 1,
        search: this.search,
        limit: 200
      }).done(function (rows) {
        that.sources = rows || [];
      }).fail(function () {
        that.error = true;
      }).always(function () {
        that.loadingSources = false;
        that.render();
      });
    },

    /** Rules changed: both lists, since a source's "blocked by" depends on the rules. */
    reloadAll: function () {
      this.loadRules();
      this.loadSources();
    },

    // ---------- rules ----------------------------------------------------

    onTypeChange: function (e) {
      this.newType = $(e.currentTarget).val();
      this.$('.js-new-pattern').attr('placeholder', this.serializeData().placeholder);
    },

    onCreate: function (e) {
      e.preventDefault();
      var hours = EXPIRY_HOURS[this.$('.js-new-expiry').val()];
      this.createRule({
        type: this.$('.js-new-type').val(),
        pattern: $.trim(this.$('.js-new-pattern').val()),
        note: $.trim(this.$('.js-new-note').val()),
        expiresAt: hours ? moment().add(hours, 'hours').valueOf() : null
      });
    },

    createRule: function (rule) {
      var that = this;
      this.formError = null;
      App.request('apiBlock:create', rule).done(function () {
        that.newType = rule.type;
        that.$('.js-rule-form')[0].reset();
        that.reloadAll();
      }).fail(function (message) {
        that.formError = message;
        that.render();
        that.$('.js-new-type').val(rule.type);
        that.$('.js-new-pattern').val(rule.pattern);
        that.$('.js-new-note').val(rule.note);
      });
    },

    // Data arriving re-renders the view: keep what is being typed in the form.
    onBeforeRender: function () {
      this.draft = this.$('.js-new-pattern').length ? {
        pattern: this.$('.js-new-pattern').val(),
        note: this.$('.js-new-note').val(),
        expiry: this.$('.js-new-expiry').val()
      } : null;
    },

    onRender: function () {
      if (this.draft) {
        this.$('.js-new-pattern').val(this.draft.pattern);
        this.$('.js-new-note').val(this.draft.note);
        this.$('.js-new-expiry').val(this.draft.expiry);
      }
    },

    onToggle: function (e) {
      var that = this;
      var rule = _.findWhere(this.rules, { id: $(e.currentTarget).data('id') });
      if (!rule) { return; }
      var expired = rule.expiresAt && rule.expiresAt <= Date.now();
      App.request('apiBlock:update', rule.id, {
        active: !rule.enforced,
        note: rule.note,
        // Re-enabling an expired rule makes it permanent rather than failing on a past date.
        expiresAt: expired ? null : rule.expiresAt
      }).done(function () {
        that.reloadAll();
      }).fail(function (message) {
        bootbox.alert(_.escape(message));
      });
    },

    onDelete: function (e) {
      var that = this;
      var rule = _.findWhere(this.rules, { id: $(e.currentTarget).data('id') });
      if (!rule) { return; }
      bootbox.confirm(_.i18n('admin.apiBlock.confirmDelete', null, 'Delete the rule') + ' <b>' +
        _.escape(rule.type + ' ' + rule.pattern) + '</b>?', function (ok) {
        if (!ok) { return; }
        App.request('apiBlock:delete', rule.id).always(function () {
          that.reloadAll();
        });
      });
    },

    ruleView: function (r) {
      var now = Date.now();
      var status = r.enforced ? 'enforced' : (!r.active ? 'inactive' : 'expired');
      return _.extend({}, r, {
        status: status,
        statusLabel: status === 'enforced' ? _.i18n('admin.apiBlock.enforced', null, 'Blocking') :
          (status === 'inactive' ? _.i18n('admin.apiBlock.inactive', null, 'Paused') :
            _.i18n('admin.apiBlock.expired', null, 'Expired')),
        expiresLabel: r.expiresAt ? (r.expiresAt > now ? moment(r.expiresAt).fromNow() :
          moment(r.expiresAt).format('D MMM YYYY HH:mm')) : _.i18n('admin.apiBlock.never', null, 'Never'),
        expiresTitle: r.expiresAt ? moment(r.expiresAt).format('D MMM YYYY HH:mm') : '',
        createdLabel: moment(r.createdAt).format('D MMM YYYY HH:mm'),
        hitsLabel: this.formatNumber(r.hitCount || 0),
        lastHitLabel: r.lastHitAt ? moment(r.lastHitAt).fromNow() : '–'
      });
    },

    // ---------- sources --------------------------------------------------

    onSourceTab: function (e) {
      this.sourceType = $(e.currentTarget).data('type');
      this.loadSources();
    },

    onPeriod: function (e) {
      this.period = $(e.currentTarget).data('period');
      this.loadSources();
    },

    onSearch: function (e) {
      e.preventDefault();
      this.search = $.trim(this.$('.js-search').val());
      this.loadSources();
    },

    onBlockSource: function (e) {
      var that = this;
      var source = this.sources[$(e.currentTarget).data('index')];
      if (!source) { return; }
      bootbox.confirm(_.i18n('admin.apiBlock.confirmBlock', null, 'Block every call from') + ' <b>' +
        _.escape(source.type + ' ' + source.value) + '</b>?', function (ok) {
        if (ok) {
          that.createRule({ type: source.type, pattern: source.value, note: '', expiresAt: null });
        }
      });
    },

    sourceView: function (s) {
      var rule = s.ruleId ? _.findWhere(this.rules, { id: s.ruleId }) : null;
      return _.extend({}, s, {
        callsLabel: this.formatNumber(s.calls || 0),
        blockedLabel: this.formatNumber(s.blockedCalls || 0),
        lastSeenLabel: moment(s.lastSeen).format('D MMM HH:00'),
        ruleLabel: rule ? rule.pattern : (s.ruleId ? '#' + s.ruleId : null),
        blockable: !s.ruleId && s.value !== '(overflow)'
      });
    },

    formatNumber: function (n) {
      return String(n || 0).replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
    }
  });
});

